(function () {
  var root = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal (with staggered children) --------------------------- */
  var targets = [].slice.call(root.querySelectorAll('.dc-reveal'));
  function show(el) {
    el.style.opacity = '1'; el.style.transform = 'none';
    [].forEach.call(el.querySelectorAll('[data-dc-stagger]'), function (k) { k.style.opacity = '1'; k.style.transform = 'none'; });
  }
  function prime(el) {
    if (reduce) return;
    el.style.opacity = '0'; el.style.transform = 'translateY(26px)';
    [].forEach.call(el.querySelectorAll('[data-dc-stagger]'), function (k, i) {
      k.style.opacity = '0'; k.style.transform = 'translateY(20px)'; k.style.transitionDelay = (i * 0.05 + 0.05) + 's';
    });
  }
  targets.forEach(prime);
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  } else { targets.forEach(show); targets = []; }
  function sweep() {
    var lim = window.innerHeight * 0.94;
    targets = targets.filter(function (el) {
      if (el.getBoundingClientRect().top >= lim) return true;
      show(el); if (io) io.unobserve(el); return false;
    });
  }
  var raf = null;
  window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sweep(); }); }, { passive: true });
  window.addEventListener('resize', sweep);
  requestAnimationFrame(sweep);

  /* ---------- collection grid: filter / sort / paginate real data -------- */
  var gridRoot = root.querySelector('[data-dc-grid]');
  if (gridRoot) {
    var ALL = JSON.parse(gridRoot.querySelector('[data-dc-collections]').textContent || '[]');
    var grid = gridRoot.querySelector('[data-dc-cards]');
    var count = root.querySelector('[data-dc-count]');
    var moreBox = root.querySelector('[data-dc-more]');
    var fill = root.querySelector('[data-dc-fill]');
    var moreL = root.querySelector('[data-dc-morelabel]');
    var emptyBox = root.querySelector('[data-dc-empty]');
    var searchEl = root.querySelector('[data-dc-search]');
    var sizeEl = root.querySelector('[data-dc-size]');

    var state = { q: '', minSize: 0, onlyNew: false, sort: 'Featured', shown: 6 };

    function rows() {
      var q = state.q.trim().toLowerCase();
      var r = ALL.filter(function (c) {
        return (q === '' || c.title.toLowerCase().indexOf(q) >= 0)
          && c.count >= state.minSize
          && (!state.onlyNew || c.isNew);
      });
      if (state.sort === 'Most products') r = r.slice().sort(function (a, b) { return b.count - a.count; });
      if (state.sort === 'Fewest products') r = r.slice().sort(function (a, b) { return a.count - b.count; });
      if (state.sort === 'A–Z') r = r.slice().sort(function (a, b) { return a.title.localeCompare(b.title); });
      return r;
    }

    function esc(s) { return (s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function card(c) {
      var img = c.image ? '<img src="' + c.image + '" alt="' + esc(c.title) + '" loading="lazy">' : '<span class="dc-ph__l">' + esc(c.title) + '</span>';
      return '<a class="dc-card" data-dc-stagger href="' + c.url + '">' +
        '<div class="dc-ph dc-card__art">' + img + (c.isNew ? '<span class="dc-card__new">New</span>' : '') + '</div>' +
        '<div class="dc-card__body">' +
        '<div class="dc-card__t">' + esc(c.title) + '</div>' +
        '<div class="dc-card__x">' + esc(c.text) + '</div>' +
        '<div class="dc-card__f"><span class="dc-card__m">' + c.count + (c.count === 1 ? ' bottle' : ' bottles') + (c.from ? ' · from ' + c.from : '') + '</span><span class="dc-card__o">Open</span></div>' +
        '</div></a>';
    }

    function paint() {
      var r = rows(), vis = r.slice(0, state.shown);
      if (count) count.textContent = r.length + (r.length === 1 ? ' collection' : ' collections');
      if (grid) { grid.innerHTML = vis.map(card).join(''); prime(grid); requestAnimationFrame(function () { show(grid); }); }
      if (emptyBox) emptyBox.hidden = r.length > 0;
      if (moreBox) {
        var can = state.shown < r.length;
        moreBox.hidden = !can;
        if (fill) fill.style.width = Math.round(Math.min(state.shown, r.length) / Math.max(r.length, 1) * 100) + '%';
        if (moreL) moreL.textContent = 'Showing ' + Math.min(state.shown, r.length) + ' of ' + r.length;
      }
      syncControls();
    }

    function syncControls() {
      [].forEach.call(root.querySelectorAll('[data-dc-sort]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-dc-sort') === state.sort)); });
      [].forEach.call(root.querySelectorAll('[data-dc-flag]'), function (b) {
        var on = state.onlyNew;
        b.setAttribute('aria-pressed', String(on));
        var mark = b.querySelector('span'); if (mark) mark.textContent = on ? '✓' : '';
      });
      var sl = root.querySelector('[data-dc-sizelabel]');
      if (sl) sl.textContent = state.minSize + '+ bottles';
    }

    [].forEach.call(root.querySelectorAll('[data-dc-sort]'), function (b) {
      b.addEventListener('click', function () { state.sort = b.getAttribute('data-dc-sort'); paint(); });
    });
    [].forEach.call(root.querySelectorAll('[data-dc-flag]'), function (b) {
      b.addEventListener('click', function () { state.onlyNew = !state.onlyNew; state.shown = 6; paint(); });
    });
    if (searchEl) searchEl.addEventListener('input', function () { state.q = searchEl.value; state.shown = 6; paint(); });
    if (sizeEl) sizeEl.addEventListener('input', function () { state.minSize = Number(sizeEl.value); state.shown = 6; paint(); });
    [].forEach.call(root.querySelectorAll('[data-dc-reset]'), function (b) {
      b.addEventListener('click', function () {
        state = { q: '', minSize: 0, onlyNew: false, sort: 'Featured', shown: 6 };
        if (searchEl) searchEl.value = '';
        if (sizeEl) sizeEl.value = 0;
        paint();
      });
    });
    var moreBtn = root.querySelector('[data-dc-loadmore]');
    if (moreBtn) moreBtn.addEventListener('click', function () { state.shown += 6; paint(); });

    paint();
  }

  /* ---------- rails: drag + arrows (occasion rail) ------------------------ */
  [].forEach.call(root.querySelectorAll('[data-dc-rail]'), function (rail) {
    var down = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, moved = false, glide = null;
    function stop() { if (glide) cancelAnimationFrame(glide); glide = null; }
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      /* let touch use native scrolling — see dl-homepage.js for why */
      if (e.pointerType === 'touch') return;
      down = true; moved = false; stop();
      sx = lx = e.clientX; sl = rail.scrollLeft; lt = performance.now(); v = 0; rail.style.cursor = 'grabbing';
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = sl - dx;
      var now = performance.now(), dt = now - lt;
      if (dt > 8) { v = (e.clientX - lx) / dt; lx = e.clientX; lt = now; }
      if (moved && e.cancelable) e.preventDefault();
    });
    function up() {
      if (!down) return;
      down = false; rail.style.cursor = 'grab';
      var vel = v * 16;
      function run() { vel *= 0.94; rail.scrollLeft -= vel; glide = Math.abs(vel) > 0.4 ? requestAnimationFrame(run) : null; }
      if (Math.abs(vel) > 1) glide = requestAnimationFrame(run);
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { rail.addEventListener(t, up); });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
  [].forEach.call(root.querySelectorAll('[data-dc-railnav]'), function (b) {
    b.addEventListener('click', function () {
      var target = root.getElementById(b.getAttribute('data-dc-railnav-target'));
      if (target) target.scrollBy({ left: Number(b.getAttribute('data-dc-railnav')) * 318, behavior: 'smooth' });
    });
  });
})();
